import {
  resetTrackingPayloadToState,
  writeTrackingPayloadToState,
} from '@epicuro-next/state/tracking';
import { createReducer, on } from '@ngrx/store';

export const basketTrackingPayloadsFeatureKey = 'tracking-payloads';

export interface State {
  payloads: {
    [key: string]: { [key: string]: unknown };
  };
}

export const initialState = {
  payloads: {},
};

export const reducer = createReducer(
  initialState,
  on(writeTrackingPayloadToState, (state, action) => {
    if (action.eventName) {
      return {
        ...state,
        payloads: {
          ...(state.payloads ?? {}),
          [action.eventName]: action.payload,
        },
      };
    }
    return {
      ...state,
    };
  }),
  on(resetTrackingPayloadToState, (state) => {
    // When search data is in payloads dont need to refresh it from state. Will be add new after searhc event triggered
    // TODO: will be removed after adding new source for empty search panel
    if ('search' in state.payloads) {
      return {
        ...initialState,
        payloads: {
          search: state.payloads,
        },
      };
    }

    return {
      ...initialState,
    };
  }),
);
